import { render, staticRenderFns } from "./HomePainPoints.vue?vue&type=template&id=7a3efdc1&scoped=true&"
import script from "./HomePainPoints.vue?vue&type=script&lang=js&"
export * from "./HomePainPoints.vue?vue&type=script&lang=js&"
import style0 from "./HomePainPoints.vue?vue&type=style&index=0&id=7a3efdc1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3efdc1",
  null
  
)

export default component.exports